import { create } from 'zustand';

type CopilotFindingEditProcessingStore = {
  processingFindingId: string | null;
  sourceChatId: string | null;
  editingFieldCount: number;
  stopSuppressionChatId: string | null;
  setProcessingFindingEdit: (args: {
    findingId: string;
    chatId: string;
    editingFieldCount?: number;
  }) => void;
  clearProcessingFindingEdit: () => void;
  releaseProcessingFindingEditForChat: (chatId: string) => void;
  suppressProcessingAfterStop: (chatId: string) => void;
  clearStopSuppression: () => void;
};

export const useCopilotFindingEditProcessingStore =
  create<CopilotFindingEditProcessingStore>((set, get) => ({
    processingFindingId: null,
    sourceChatId: null,
    editingFieldCount: 0,
    stopSuppressionChatId: null,

    setProcessingFindingEdit: ({ findingId, chatId, editingFieldCount }) => {
      set({
        processingFindingId: findingId,
        sourceChatId: chatId,
        editingFieldCount: editingFieldCount ?? get().editingFieldCount,
      });
    },

    clearProcessingFindingEdit: () => {
      set({
        processingFindingId: null,
        sourceChatId: null,
        editingFieldCount: 0,
      });
    },

    releaseProcessingFindingEditForChat: (chatId) => {
      if (get().sourceChatId !== chatId) {
        return;
      }

      set({
        processingFindingId: null,
        sourceChatId: null,
        editingFieldCount: 0,
      });
    },

    suppressProcessingAfterStop: (chatId) => {
      set({
        stopSuppressionChatId: chatId,
        processingFindingId: null,
        sourceChatId: null,
        editingFieldCount: 0,
      });
    },

    clearStopSuppression: () => {
      set({ stopSuppressionChatId: null });
    },
  }));
